
<div class="container-fluid alone full-height">
    <div class="row">
      <div class="col-6">
        <h3 class="section-title mb-2">
            {{ 'CONSUMPTION.CONSUMPTION.HAND_DISINFECTANT' | translate }}
        </h3>
      </div>
      <div class="col-6" *ngFor="let item of consumptionData">
        <ul class="advise-container d-flex justify-content-end">
            <li> {{item.year}} </li>
            <li> {{item.wardName | translate | labelSanitizer}} </li>
            <li> {{item.departmentName | translate | labelSanitizer}} </li>
        </ul>
      </div>
    </div>
  </div>
<form [formGroup]="periodInYearForm">


    <table>
        <thead>
            <tr>
                <th scope="col">{{ 'CONFIGURE.PERIOD_1' | translate }}
                    <span class="italicFont"> {{'CONSUMPTION.IN_YEAR' | translate}}</span>
                </th>
                <th class="border-left" scope="col"> {{ amountMeasure() }}
                    <span class="italicFont"> ({{unitMeasure()}})</span>
                </th>
                <th class="border-left" scope="col">{{'CONSUMPTION.PATIENT_DAYS' | translate}}
                    <span class="italicFont"> {{"CONSUMPTION.IN_DAYS" | translate}}</span>
                </th>
                <th *ngIf="haiEnabled" class="border-left" scope="col">{{'CONSUMPTION.HAI' | translate}}
                    <span class="italicFont"> {{'CONSUMPTION.OCCURRENCES' | translate}}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>{{'CONSUMPTION.YEAR' | translate}}</td>
                <td>
                  <input *ngIf="isLiters()" type="text" onlynumber=true class="form-control" min="0" [mask]="'separator.2'" [thousandSeparator]="''" [dropSpecialCharacters]="false" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{consumptionPeriodDetailNew.consumptionValue}}" formControlName="consumptionValue">
                  <input *ngIf="isMilliliters()" type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{consumptionPeriodDetailNew.consumptionValue}}" formControlName="consumptionValue">
                </td>
                <td>
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" value="{{consumptionPeriodDetailNew.patientDays}}" formControlName="patientDays">
                </td>
                <td *ngIf="haiEnabled">
                  <input type="text" onlynumber=true class="form-control" min="0" mask="00000000" [ngClass]="viewConsumption ? '' : 'readOnlyText'" formControlName="haiOccurrences">
                </td>
            </tr>
        </tbody>
      </table>


</form>

<div class="col-auto d-flex justify-content-end mt-3">
    <button class="btn btn-bd" *ngIf="!viewConsumption" (click)="EditConsumption()">{{ 'CONFIGURE.EDIT' | translate }}</button>
    <button *ngIf="viewConsumption"  (click)="cancelConsupmtionPeriod()" class="btn btn-cancel-bordered-bd mr-4">{{ translationKeys.Authorization.Cancel | translate }}</button>
    <button *ngIf="viewConsumption" class="btn btn-bd" (click)="updateConsumptionPeriod()">{{ translationKeys.Observation.Update | translate }}</button>
</div>
<br>
